"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAttributesPlugin = void 0;
const bowser_1 = require("bowser");
const omitEmptyProperties_1 = require("../lib/omitEmptyProperties");
exports.userAttributesPlugin = {
    name: 'User Attributes',
    type: 'enrichment',
    version: '1.0.0',
    isLoaded: () => true,
    load: () => Promise.resolve(),
    track: (ctx) => {
        var _a, _b, _c;
        try {
            const userAgent = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || '';
            let attributes = getAttributes(userAgent);
            attributes = Object.assign(Object.assign({}, ((_c = (_b = (_a = ctx.event) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.userAttributes) !== null && _c !== void 0 ? _c : {})), attributes);
            ctx.updateEvent('context.userAttributes', attributes);
        }
        catch (e) {
            console.log(e);
        }
        return ctx;
    },
    page: (ctx) => {
        var _a, _b, _c;
        try {
            const userAgent = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || '';
            let attributes = getAttributes(userAgent);
            attributes = Object.assign(Object.assign({}, ((_c = (_b = (_a = ctx.event) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.userAttributes) !== null && _c !== void 0 ? _c : {})), attributes);
            ctx.updateEvent('context.userAttributes', attributes);
        }
        catch (e) { }
        return ctx;
    },
    identify: (ctx) => {
        var _a, _b, _c;
        try {
            const userAgent = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || '';
            let attributes = getAttributes(userAgent);
            attributes = Object.assign(Object.assign({}, ((_c = (_b = (_a = ctx.event) === null || _a === void 0 ? void 0 : _a.traits) === null || _b === void 0 ? void 0 : _b.userAttributes) !== null && _c !== void 0 ? _c : {})), attributes);
            ctx.updateEvent('traits.userAttributes', attributes);
        }
        catch (e) { }
        return ctx;
    },
};
function getAttributes(userAgent) {
    const browser = (0, bowser_1.getParser)(userAgent);
    return (0, omitEmptyProperties_1.omitEmptyProperties)({
        browser: browser.getBrowserName(),
        browserVersion: browser.getBrowserVersion(),
        device: browser.getPlatformType(),
        deviceOS: browser.getOSName(),
        deviceOSVersion: browser.getOSVersion(),
    });
}
//# sourceMappingURL=userAttributes.js.map